/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateUserDto
 */
export interface CreateUpdateUserDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateUserDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateUserDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateUserDto
     */
    licenseNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateUserDto
     */
    pwz?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateUserDto
     */
    occupationalMedicineDoctorIdentifier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateUserDto
     */
    uid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateUserDto
     */
    pin?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateUserDto
     */
    admin?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateUserDto
     */
    superadmin?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateUserDto
     */
    emailWithReferral?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateUserDto
     */
    active?: boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateUserDto
     */
    roles?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateUserDto
     */
    companyIds?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateUserDto
     */
    photo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateUserDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateUserDto
     */
    signP1WithSzafir?: boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateUserDto
     */
    healthcareFacilities?: Array<string> | null;
}

/**
 * Check if a given object implements the CreateUpdateUserDto interface.
 */
export function instanceOfCreateUpdateUserDto(value: object): value is CreateUpdateUserDto {
    return true;
}

export function CreateUpdateUserDtoFromJSON(json: any): CreateUpdateUserDto {
    return CreateUpdateUserDtoFromJSONTyped(json, false);
}

export function CreateUpdateUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateUserDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'email': json['email'] == null ? undefined : json['email'],
        'licenseNumber': json['licenseNumber'] == null ? undefined : json['licenseNumber'],
        'pwz': json['pwz'] == null ? undefined : json['pwz'],
        'occupationalMedicineDoctorIdentifier': json['occupationalMedicineDoctorIdentifier'] == null ? undefined : json['occupationalMedicineDoctorIdentifier'],
        'uid': json['uid'] == null ? undefined : json['uid'],
        'pin': json['pin'] == null ? undefined : json['pin'],
        'admin': json['admin'] == null ? undefined : json['admin'],
        'superadmin': json['superadmin'] == null ? undefined : json['superadmin'],
        'emailWithReferral': json['emailWithReferral'] == null ? undefined : json['emailWithReferral'],
        'active': json['active'] == null ? undefined : json['active'],
        'roles': json['roles'] == null ? undefined : json['roles'],
        'companyIds': json['companyIds'] == null ? undefined : json['companyIds'],
        'photo': json['photo'] == null ? undefined : json['photo'],
        'description': json['description'] == null ? undefined : json['description'],
        'signP1WithSzafir': json['signP1WithSzafir'] == null ? undefined : json['signP1WithSzafir'],
        'healthcareFacilities': json['healthcareFacilities'] == null ? undefined : json['healthcareFacilities'],
    };
}

export function CreateUpdateUserDtoToJSON(value?: CreateUpdateUserDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'email': value['email'],
        'licenseNumber': value['licenseNumber'],
        'pwz': value['pwz'],
        'occupationalMedicineDoctorIdentifier': value['occupationalMedicineDoctorIdentifier'],
        'uid': value['uid'],
        'pin': value['pin'],
        'admin': value['admin'],
        'superadmin': value['superadmin'],
        'emailWithReferral': value['emailWithReferral'],
        'active': value['active'],
        'roles': value['roles'],
        'companyIds': value['companyIds'],
        'photo': value['photo'],
        'description': value['description'],
        'signP1WithSzafir': value['signP1WithSzafir'],
        'healthcareFacilities': value['healthcareFacilities'],
    };
}

